import type { RegionAliases } from "@entity/Region";
import type { Incident } from "@entity/Incident";
import type { ServiceReport } from "@entity/ServiceReport";

/**
 * Builds one incident per alert in report order, including alerts for Other services.
 * Resolves the region once per report item so a previous alias cannot become the next lookup key.
 */
export function deriveIncidents(report: ServiceReport, regionAliases: RegionAliases): Incident[] {
  const result: Incident[] = [];

  report.forEach((item) => {
    const alerts = Object.entries(item.alerts);
    if (alerts.length === 0) {
      return;
    }

    const regionKey = item.region.toLowerCase();
    const region = Object.prototype.hasOwnProperty.call(regionAliases, regionKey)
      ? regionAliases[regionKey]
      : regionKey;

    for (const [id, alert] of alerts) {
      result.push({ ...item, id, alert, level: alert.level, region });
    }
  });

  return result;
}